import urlRegex from 'url-regex';

export default (string, options={}) => urlRegex(options).test(string);
